<template>
  <div>
    <div class="header-icons">
      <el-dropdown size="medium" type="primary" @command="downloadCommand" placement="bottom" v-if="PIC==user_id||customerPIC==user_id">
        <svg-icon icon-class="Download" className="icon-download"/>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="downloadContracts">合同</el-dropdown-item>
          <el-dropdown-item command="downloadInvoices">发票</el-dropdown-item>
          <el-dropdown-item command="downloadPaymentReceipts">付款</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-tooltip effect="dark" :content="isSearching?'取消搜索':'搜索'" placement="top">
        <svg-icon v-if="!isSearching&&(PIC==user_id||customerPIC==user_id)" icon-class="Search" className="icon-search" @click="openSearcher"/>
        <svg-icon v-if="isSearching&&(PIC==user_id||customerPIC==user_id)" icon-class="CancelSearch" className="icon-search" @click="cancelSearch"/>
      </el-tooltip>      
    </div>
    <el-row>
    <el-col :span="24">
    <el-card shadow="always" body-style="text-align:center;padding:0px;" id='tableCard'>
      <el-table :data="items" header-align="center" size="small" highlight-current-row :cell-style="{padding:'5px',fontSize:'13px',borderColor:'#ddd'}" ref="multipleTable" height='calc(100vh - 45px)' border stripe :header-cell-style="headerStyle" :row-style="{height:'45px'}" :show-summary="PIC==user_id||customerPIC==user_id" :summary-method="getSummaries" @selection-change="selectedItemChange" @row-click="openDetailDialog">
          <el-table-column type="selection" width="40" align="center"></el-table-column>
          <el-table-column type="index" label="行号" width="70" align="center"></el-table-column>
          <el-table-column label="供应商" min-width="120" align="center" :formatter="calcSupplier"></el-table-column>
          <el-table-column label="订单金额" min-width="90" align="center" :formatter="calcOrderAmount"></el-table-column>
          <el-table-column label="采购金额" min-width="90" align="center" :formatter="calcContractAmount"></el-table-column>
        
          <el-table-column label="已付款额" min-width="90" align="center" :formatter="calcPaidAmount"></el-table-column>
          <el-table-column label="付款进度" width="80" align="center" :formatter="calcPaidSchedule"></el-table-column>

          <el-table-column label="已开票额" min-width="90" align="center" :formatter="calcInvoiceAmount"></el-table-column>
          <el-table-column label="开票进度" width="80" align="center" :formatter="calcInvoiceSchedule"></el-table-column>

          <el-table-column label="计划到货期" width="90" align="center" :formatter="calcDeliveryTime"></el-table-column>
          <el-table-column label="到货状态" width="70" align="center" :formatter="calcCheckinStatus"></el-table-column>
          <el-table-column label="采购合同" align="center" width="80">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.contracts" :key="index" style="display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;">
                <div v-if="item.attachment&&item.attachment.path">
                  <el-tooltip class="item" effect="dark" :content="item.attachment.filename" placement="top">
                    <el-image class="image" v-if="['.pdf','.PDF'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.xls','.xlsx','.XLS','.XLSX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.doc','.docx','.DOC','.DOCX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.ppt','.pptx','.PPT','.PPTX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewImage(item.attachment.path)"></el-image>
                    <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>  
          <el-table-column label="付款凭证" align="center" width="80">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.payments" :key="index" style="display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;">
                <div v-if="item.attachment&&item.attachment.path">
                  <el-tooltip class="item" effect="dark" :content="item.attachment.filename" placement="top">
                    <el-image class="image" v-if="['.pdf','.PDF'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.xls','.xlsx','.XLS','.XLSX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.doc','.docx','.DOC','.DOCX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.ppt','.pptx','.PPT','.PPTX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewImage(item.attachment.path)"></el-image>
                    <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="采购发票" align="center" width="80">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.invoices" :key="index" style="display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;">
                <div v-if="item.attachment&&item.attachment.path">
                  <el-tooltip class="item" effect="dark" :content="item.attachment.filename" placement="top">
                    <el-image class="image" v-if="['.pdf','.PDF'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.xls','.xlsx','.XLS','.XLSX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.doc','.docx','.DOC','.DOCX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.ppt','.pptx','.PPT','.PPTX'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                    <el-image class="image" v-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(item.attachment.filename.substring(item.attachment.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewImage(item.attachment.path)"></el-image>
                    <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(item.attachment.path)"></el-image>
                  </el-tooltip>
                </div>
              </div>
             </template>
          </el-table-column>
          <el-table-column label="负责人" width="80" align="center">
            <template slot-scope="scope">
              <el-select size="mini" v-model="scope.row.PIC" placeholder="负责人" @change="PICChange($event,scope.row)" :disabled="PIC!=user_id">
                <el-option
                  v-for="item in customerACL"
                  :key="item._id"
                  :label="item.nickname"
                  :value="item._id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
      </el-table>
    </el-card>
    </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/http'
import Store from '@/store'
import searcherDialog from './Searcher/index.js'
import detailDialog from './Detail/index'
import dateformat from 'dateformat' 
import jsZip from 'jszip'
import fileSave from 'file-saver'

export default {
  props:['row','PIC'],
  data() {
    return {
      items:[],
      selectedItems:[],
      isSearching:false,
      user_id:Store.state.user_id,
      customerACL:[],
      supplierList:[],
      customerId:Store.state.item_content._id,
      customerPIC:Store.state.item_content.PIC._id,
    }
  },
  methods:{
    async fetch(){
      if(this.PIC==this.user_id||this.customerPIC==this.user_id){
        const res=await http.get(`/crm/purchaseDetail/purchaseId/${this.row._id}`,{params:{purchaseId:this.row._id}});      
        this.items=res.data  
      }else{
        const res=await http.get(`/crm/purchaseDetail/purchaseId/${this.row._id}`,{params:{purchaseId:this.row._id,PIC:this.user_id}});   
        this.items=res.data
      }
    },
    async refreshProcurementData(){
      await http.post('/crm/purchaseDetail/packing',{orderId:this.row.order_details[0]._id,purchaseId:this.row._id});
      this.fetch()
    },
    async getCustomerACL() {
        const res=await http.get(`/crm/customer/customerACL/${this.customerId}`)
        this.customerACL = res.data
    },
    openDetailDialog(row, column, event){
      if(["采购合同","付款凭证","采购发票","负责人","操作"].includes(column.label)) return
      let suppliername=''
      this.supplierList.forEach(el => {
        if(el._id==row.supplier){
          suppliername=el.name
        }
      });
      detailDialog(suppliername,row,this.row.sn,this.fetch)
    },
    openSearcher(){
      searcherDialog(this.supplierList,this.row._id,this.customerACL,this.handleSearch)
    },
    cancelSearch(){
      this.isSearching=false
      this.fetch()
    },
    handleSearch(data){
      this.items=data
      this.isSearching=true
    },
    calcOrderAmount(row, column, cellValue, index){
      let orderAmount=0
      if(row.items.length){
        row.items.forEach(v=>{
          orderAmount=orderAmount+ v.UnitPrice*v.Quantity
        })
      }
      if(this.row.order_details[0].currency=='CNY'){
        return orderAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
      }else{
        return orderAmount.toLocaleString('en-US', { style: 'currency', currency:'USD' })
      }
    },
    calcContractAmount(row, column, cellValue, index){
      let contractAmount=0
      let currency='CNY'
      if(row.contracts.length){
        row.contracts.forEach(v=>{
          contractAmount=contractAmount+ v.contractAmount
          currency=v.currency
        })
      }
      if(currency=='CNY'){
        return contractAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
      }else{
        return contractAmount.toLocaleString('en-US', { style: 'currency', currency:'USD' })
      }
    },
    calcPaidAmount(row, column, cellValue, index){
      let paidAmount=0
      let currency='CNY'
      if(row.payments.length){
        row.payments.forEach(v=>{
          paidAmount=paidAmount+ v.amount
          currency=v.currency
        })
      }
      if(currency=='CNY'){
        return paidAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
      }else{
        return paidAmount.toLocaleString('en-US', { style: 'currency', currency:'USD' })
      }
    },
    calcInvoiceAmount(row, column, cellValue, index){
      let invoiceAmount=0
      if(row.invoices.length){
        row.invoices.forEach(v=>{
          invoiceAmount=invoiceAmount+ v.amount
        })
      }
      return invoiceAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })

    },
    calcDeliveryTime(row, column, cellValue, index){
      if(row.contracts.length){
        const date=new Date(row.contracts[0].signedDate)
        const m=date.getTime()+row.contracts[0].deliveryTime*86400000
        return dateformat(new Date(m),"yyyy-mm-dd")
      }
    },
    calcPaidSchedule(row, column, cellValue, index){
      let paidAmount=0
      let contractAmount=0      
      if(row.payments.length){
        row.payments.forEach(v=>{
          paidAmount=paidAmount+ v.amount
        })
      }
      if(row.contracts.length){
        row.contracts.forEach(v=>{
          contractAmount=contractAmount+ v.contractAmount
        })
      }
      return (paidAmount*100/contractAmount).toFixed(2)+'%'
    },
    calcInvoiceSchedule(row, column, cellValue, index){
      let invoiceAmount=0
      let contractAmount=0      
      if(row.invoices.length){
        row.invoices.forEach(v=>{
          invoiceAmount=invoiceAmount+ v.amount
        })
      }
      if(row.contracts.length){
        row.contracts.forEach(v=>{
          contractAmount=contractAmount+ v.contractAmount
        })
      }
      return (invoiceAmount*100/contractAmount).toFixed(2)+'%'
    },
    calcCheckinStatus(row, column, cellValue, index){
      let arrived=0
      row.items.map(item=>{
        const QTY_Checkins=item.Checkins.length>0?item.Checkins[0].totalAmount:0
        if(QTY_Checkins==item.Quantity){
          arrived++
        }
      })
      return arrived+'/'+row.items.length
    },
    calcSupplier(row, column, cellValue, index){
      let suppliername=''
      this.supplierList.forEach(el => {
        if(el._id==row.supplier){
          suppliername=el.name
        }
      });
      return suppliername
    },
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '总计';
          }else if(index === 3){
            let amount=0
            for(let i of data){
              if(i.items.length){
                i.items.forEach(v=>{
                    amount=amount+v.UnitPrice*v.Quantity
                })
              }
            }
            if(this.row.order_details[0].currency=='CNY'){
              sums[index]=amount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
            }else{
              sums[index]=amount.toLocaleString('en-US', { style: 'currency', currency:'USD' })
            }
          }else if(index === 4){
            let CNYAmount=0
            let USDAmount=0
            for(let i of data){
              if(i.contracts.length){
                i.contracts.forEach(v=>{
                  if(v.currency=='CNY'){
                    CNYAmount=CNYAmount+v.contractAmount
                  }else{
                    USDAmount=USDAmount+v.contractAmount
                  }
                })
              }
            }
            sums[index]=CNYAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })+'\n'+USDAmount.toLocaleString('en-US', { style: 'currency', currency:'USD' })
          }else if(index === 5){
            let paidCNYAmount=0
            let paidUSDAmount=0
            for(let i of data){
              if(i.payments.length){
                i.payments.forEach(v=>{
                  if(v.currency=='CNY'){
                    paidCNYAmount=paidCNYAmount+v.amount
                  }else{
                    paidUSDAmount=paidUSDAmount+v.amount
                  }
                })
              }
            }
            sums[index]=paidCNYAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })+'\n'+paidUSDAmount.toLocaleString('en-US', { style: 'currency', currency:'USD' })
          }else if(index === 7){
            let invoiceAmount=0
            for(let i of data){
              if(i.invoices.length){
                i.invoices.forEach(v=>{
                  invoiceAmount=invoiceAmount+v.amount
                })
              }
            }
            sums[index]=invoiceAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
          }else if(index === 9){
            let DT=0
            for(let i of data){
              if(i.contracts.length){
                const date=new Date(i.contracts[0].signedDate)
                const m=date.getTime()+i.contracts[0].deliveryTime*86400000
                if(m>DT){
                  DT=m
                }                
              }              
            }
            sums[index]="最晚到货期"+'\n'+dateformat(new Date(DT),"yyyy-mm-dd")
          }else if(index === 10){
            let arrivedItemNumber=0
            let totalItemNumber=0
            for(let i of data){
              let arrived=0
              i.items.map(item=>{
                const QTY_Checkins=item.Checkins.length>0?item.Checkins[0].totalAmount:0
                if(QTY_Checkins==item.Quantity){
                  arrived++
                }
              })
              arrivedItemNumber=arrivedItemNumber+arrived
              totalItemNumber=totalItemNumber+i.items.length
            }
            sums[index]=arrivedItemNumber+'/'+totalItemNumber
          }else {
            sums[index] = '';
          }
        });
        return sums;
    },
    async previewAttachment(file){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      window.open(res.data)
    },
    async previewImage(file){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      this.$hevueImgPreview({url:res.data})
    },
    async PICChange(e,row){
      if(this.selectedItems.length){ 
        const ids=this.selectedItems.map(item=>item._id)
        await http.put(`/crm/purchaseDetail/ids`,{ids,data:{$set:{PIC:e}}});
        this.fetch()
      }else{
        http.put(`/crm/purchaseDetail/id/${row._id}`,{$set:{PIC:e}});
      }
    },
    selectedItemChange(){
      this.selectedItems = this.$refs.multipleTable.selection
    },
    async fetchSupplier(){
      const res=await http.get('/srm/supplier'); 
      this.supplierList=res.data
    },
    downloadCommand(command) {
      if(command=='downloadContracts'){
        this.downloadContracts()
      }else if(command=='downloadInvoices'){
        this.downloadInvoices()
      }else{
        this.downloadPaymentReceipts()
      }
    },
    async downloadPaymentReceipts(){
      const res = await http.get(`/crm/payment/purchaseId/${this.row._id}`,{params:{user_id:this.user_id}});
      const zip=jsZip()
      const cache={}
      const Promises=[]
      res.data.forEach(item=>{
        if(item.attachment){
          const promise=this.getFile(item.attachment.path).then(data=>{
            const type=item.attachment.path.substring(item.attachment.path.lastIndexOf("."))
            const file_name=`${item.payee.name}_${dateformat(item.paymentDate,"yyyymmdd")}${type}` //获取文件名
            zip.file(file_name,data,{binary:true})//逐个添加文件到zip
            cache[file_name]=data
          })
          Promises.push(promise)
        }
      })
      Promise.all(Promises).then(()=>{
        zip.generateAsync({type:'blob'}).then(content=>{
          fileSave.saveAs(content,`采购单#${this.row.sn}_付款凭据.zip`)
        })
      })
    },
    async downloadInvoices(){
      const res = await http.get(`/crm/invoice/purchaseId/${this.row._id}`,{params:{user_id:this.user_id}});
      const zip=jsZip()
      const cache={}
      const Promises=[]
      res.data.forEach(item=>{
        if(item.attachment){
          const promise=this.getFile(item.attachment.path).then(data=>{
            const type=item.attachment.path.substring(item.attachment.path.lastIndexOf("."))
            const file_name=`${item.signatory.name}_${item.sn}${type}` //获取文件名
            zip.file(file_name,data,{binary:true})//逐个添加文件到zip
            cache[file_name]=data
          })
          Promises.push(promise)
        }
      })
      Promise.all(Promises).then(()=>{
        zip.generateAsync({type:'blob'}).then(content=>{
          fileSave.saveAs(content,`采购单#${this.row.sn}_发票.zip`)
        })
      })
    },
    //**批量下载**//
    async downloadContracts(){
      const res = await http.get(`/crm/contract/purchaseId/${this.row._id}`,{params:{user_id:this.user_id}});
      const zip=jsZip()
      const cache={}
      const Promises=[]
      res.data.forEach(item=>{
        if(item.attachment){
          const promise=this.getFile(item.attachment.path).then(data=>{
            const type=item.attachment.path.substring(item.attachment.path.lastIndexOf("."))
            const file_name=`${item.signatory.name}_${item.sn}${type}` //获取文件名
            zip.file(file_name,data,{binary:true})//逐个添加文件到zip
            cache[file_name]=data
          })
          Promises.push(promise)
        }
      })
      Promise.all(Promises).then(()=>{
        zip.generateAsync({type:'blob'}).then(content=>{
          fileSave.saveAs(content,`采购单#${this.row.sn}_合同.zip`)
        })
      })
    },
    //**批量下载**//
    getFile(url){
      return new Promise((resolve,reject)=>{
        this.$axios({
          method:'get',
          url,
          responseType:'arraybuffer'
        }).then(data=>{
          resolve(data.data)
        }).catch(error=>{
          reject(error.toString())
        })
      })
    },
  },
  updated(){
    this.$nextTick(()=>{
      this.$refs.multipleTable.doLayout()
    })
  },
  created(){
    this.refreshProcurementData()
    this.getCustomerACL()
    this.fetchSupplier()
  }
};
</script>
<style scoped>
.editor-dialog>>>.el-dialog__header{
  padding: 0;
}
.editor-dialog>>>.el-dialog__body{
  padding: 2px;
}
#tableCard >>>.el-table .cell{
  line-height: 1.3!important;
  padding: 0;
  white-space:break-spaces;
}
.el-table{
  overflow: visible!important;
}
.el-table .cell p{
  margin: 0!important;
}
/*鼠标移入某行时的背景色*/
#tableCard >>>.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fad8bca4!important;
  cursor: pointer;
}
#tableCard >>>.el-table__body tr.current-row > td {
  background-color: #c6e4f8b4 !important;
}
#tableCard>>>.el-input__suffix{
  display: none;
}
#tableCard>>>.el-input__inner{
  padding-right: 10px;
  padding-left:10px;
  text-align: center;
}
.icon-search{
  font-size: 23px;
  cursor: pointer;
  margin-left:13px ;
}
.icon-download {
  font-size:24px;
  color: green;
  cursor: pointer;
}
.icon-preview-class{
  font-size: 23px;
}
.header-icons{
  position: fixed;
  top: 9px;
  right: 15px;
  width: 180px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: right;
  align-items: center;
  z-index: 2000;
}
.el-image{
  height: 43px;
  width: 38px;
  margin: 2px;
}
</style>
